"use client";

import cn from "clsx";

import type { ReactNode } from "react";

import { useAdvertory } from "../Advertory/AdvertoryContext";
import styles from "./StickySideAd.module.scss";

/** Presentation-only sticky column for Advertory widescreen placements. */
const StickySideAd = ({
  children,
  hasBottomGradientStyle,
}: {
  children?: ReactNode;
  hasBottomGradientStyle?: boolean;
}) => {
  const { enabled } = useAdvertory();

  if (!enabled) return null;

  return (
    <div
      data-advertory-sticky-side="true"
      data-testid="stickyside-component"
      className={cn(
        styles.wideScreenAdAnchor,
        styles.reserved,
        hasBottomGradientStyle && styles.bottomGradient,
      )}
    >
      <div className={styles.widescreenAd}>{children}</div>
    </div>
  );
};

export { StickySideAd };
